module.exports = __webpack_public_path__ + "img/login.c37eac82.png";